<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-bar class="search-bar" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20"><process-table :scrId="scrId" /></div>
		</div>
		<process-registration-popup :scrId="scrId" />
	</div>
</template>

<script>
import { SearchBar } from './Search';
import { ProcessTable } from './Table';
import { ProcessRegistrationPopup } from './ProcessRegistrationPopup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchBar,
		ProcessTable,
		ProcessRegistrationPopup
	}
};
</script>

<style></style>
